module.exports = __webpack_public_path__ + "static/media/commercial_cover_credit_card_skrill_moneybookers-512.78a1ffcc.png";